import { PlanningBlock } from "../models/planning-block/planning-block.interface";
export function isOfSelectedContainerState(planningblock: PlanningBlock, containerStates: string[]): boolean {
  if (!containerStates || !containerStates.length) {
    return true;
  }
  return containerStates.indexOf(planningblock.containerStatus) > -1;

    }
